import UserPreferences from './UserPreferences';
import PortalPicker from './PortalPicker';
import { OnboardingProgress } from './OnboardingProgress';
import { InviteLink } from './InviteLink';
import { AccountExtras } from './AccountExtras';
import AccountFooter from './AccountFooter';
import { BusinessUnitPicker } from './BusinessUnitPicker';
import { hasCustomBusinessUnits } from '../../utils/businessUnitsUtils';
import RedesignedNavFeedback from './RedesignedNavFeedback';
import { MaybeOptInOptOutAccountMenuItem } from '../../features/spotlight-onboarding-2025/components/MaybeOptInOptOutAccountMenuItem';
import { AccountAlert } from './AccountAlert';
import { useAppSelector } from '../../hooks';
import { getIsHubless } from '../../reducers/Portal';
import { HublessAccountsMenu } from './HublessAccountsMenu';
import { withErrorBoundary } from '../ErrorBoundary';
import memoWithDisplayName from '../../utils/memoWithDisplayName';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const _AccountsMenu = ({
  avatarUrl,
  accountName,
  userName,
  userEmail,
  scopes,
  accounts,
  businessUnits,
  businessUnit,
  isDevPortal,
  hasProjectAccess,
  isEnrolledInOnboarding
}) => {
  const isHubless = useAppSelector(getIsHubless);
  const businessUnitScopeIncluded = scopes.includes('business-units-access');
  const usersWriteScopeIncluded = scopes.includes('users-write');
  const showBusinessUnitPicker = businessUnitScopeIncluded && businessUnit && hasCustomBusinessUnits(businessUnits);
  if (isHubless) {
    return /*#__PURE__*/_jsx(HublessAccountsMenu, {
      avatarUrl: avatarUrl,
      userName: userName,
      userEmail: userEmail
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(AccountAlert, {}), /*#__PURE__*/_jsx(UserPreferences, {
      avatarUrl: avatarUrl,
      userName: userName,
      userEmail: userEmail
    }), /*#__PURE__*/_jsx(MaybeOptInOptOutAccountMenuItem, {}), /*#__PURE__*/_jsx(RedesignedNavFeedback, {}), /*#__PURE__*/_jsx(PortalPicker, {
      accountName: accountName,
      accounts: accounts
    }), showBusinessUnitPicker && /*#__PURE__*/_jsx(BusinessUnitPicker, {
      currentBusinessUnit: businessUnit,
      businessUnits: businessUnits
    }), /*#__PURE__*/_jsx(OnboardingProgress, {
      isEnrolledInOnboarding: isEnrolledInOnboarding
    }), usersWriteScopeIncluded && /*#__PURE__*/_jsx(InviteLink, {}), /*#__PURE__*/_jsx(AccountExtras, {
      isDevPortal: isDevPortal,
      hasProjectAccess: hasProjectAccess
    }), /*#__PURE__*/_jsx(AccountFooter, {})]
  });
};
export const AccountsMenu = withErrorBoundary(memoWithDisplayName('AccountsMenu', _AccountsMenu), {
  boundaryName: 'AccountsMenu'
});